export default __webpack_public_path__ + "static/media/mv.baa407eb.svg";